import React from 'react';
import { Link } from 'react-router-dom';

export default function FeaturedPrograms() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="w-[100%] max-w-6xl 2xl:max-w-5xl mx-auto px-4 sm:px-6 md:px-8">
        
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-light text-gray-900">
            Discover Our <span className="font-bold text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(90deg, rgba(109,12,34,1) 0%, rgba(14,56,107,1) 76%)' }}>Programs</span>
          </h2>
          <p className="text-sm sm:text-base text-gray-600 mt-2 max-w-2xl mx-auto">
            Explore pathways designed to validate ideas, grow ventures, and enhance capabilities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          
          <div className="md:col-span-3 bg-gray-50 rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col md:flex-row items-center group transition-shadow hover:shadow-md" data-aos="fade-up">
            <div className="w-full md:w-[45%] h-64 md:h-80 overflow-hidden">
               <img 
                 src="/images/pup-pylon-awards-night.jpg" 
                 alt="PUP Pylon Awards Night" 
                 className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                 onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1200&q=80' }}
               />
            </div>
            <div className="w-full md:w-[55%] p-8 sm:p-10 md:p-12">
               <span className="text-xs font-bold tracking-widest text-[#6D0C22] uppercase mb-2 block">Featured Program</span>
               <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">PUP PYLON AWARDS NIGHT</h3>
               <p className="text-xs sm:text-sm font-bold text-gray-500 uppercase tracking-widest mb-4">Networking</p>
               <p className="text-gray-600 mb-6 leading-relaxed text-sm sm:text-base">
                 We proudly invite all PUP alumni to join us for an inspiring evening of innovation,
                 recognition, and meaningful connections at the Pylon Awards Night!
               </p>
               <Link 
                  to="/programs"
                  className="px-8 py-3 rounded-full font-medium transition text-sm text-white shadow-md hover:shadow-lg hover:-translate-y-0.5 inline-block"
                  style={{ background: 'linear-gradient(90deg, rgba(109,12,34,1) 0%, rgba(14,56,107,1) 76%)' }}
                >
                  Learn More
                </Link>
            </div>
          </div>
          
          {/* Incubation: Dagitab */}
          <div className="col-span-1 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden group hover:shadow-md transition-shadow" data-aos="fade-up" data-aos-delay="100">
            <div className="h-48 overflow-hidden">
              <img src="/images/dagitab.jpg" alt="Dagitab Incubation" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
            </div>
            <div className="p-6">
               <h4 className="text-xl font-bold text-gray-900 mb-1">Dagitab Incubation</h4>
               <p className="text-[10px] sm:text-xs font-bold tracking-widest text-gray-500 uppercase mb-3">Incubation</p>
               <p className="text-sm text-gray-600 mb-6">A comprehensive six-month incubation program for aspiring innovators, early-stage startups, and faculty technopreneurs.</p>
               <Link to="/programs" className="text-sm font-bold text-[#0E386B] hover:text-[#6D0C22] transition-colors flex items-center gap-1">
                 Discover More <span aria-hidden="true">&rarr;</span>
               </Link>
            </div>
          </div>

          {/* Pre-Incubation: SINDI */}
          <div className="col-span-1 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden group hover:shadow-md transition-shadow" data-aos="fade-up" data-aos-delay="200">
            <div className="h-48 overflow-hidden">
              <img src="/images/img-3.png" alt="SINDI Program" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80' }}/>
            </div>
            <div className="p-6">
               <h4 className="text-xl font-bold text-gray-900 mb-1">SINDI Program</h4>
               <p className="text-[10px] sm:text-xs font-bold tracking-widest text-gray-500 uppercase mb-3">Pre-Incubation</p>
               <p className="text-sm text-gray-600 mb-6">Shaping Innovators & New Ventures through Design Ideation. Perfect for early concept validation and team building.</p>
               <Link to="/programs" className="text-sm font-bold text-[#0E386B] hover:text-[#6D0C22] transition-colors flex items-center gap-1">
                 Discover More <span aria-hidden="true">&rarr;</span>
               </Link>
            </div>
          </div>

          {/* Pre-Incubation: Cohort III */}
          <div className="col-span-1 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden group hover:shadow-md transition-shadow" data-aos="fade-up" data-aos-delay="300">
            <div className="h-48 overflow-hidden">
              <img src="/images/call-for-cohort-3.png" alt="Call for Cohort III" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1556761175-5973dc0f32d7?w=600&q=80' }}/>
            </div>
            <div className="p-6">
               <h4 className="text-xl font-bold text-gray-900 mb-1">Call for Cohort III</h4>
               <p className="text-[10px] sm:text-xs font-bold tracking-widest text-gray-500 uppercase mb-3">Pre-Incubation</p>
               <p className="text-sm text-gray-600 mb-6">Join our upcoming batch of innovators to validate ideas, grow your ventures, and expand your networks.</p>
               <Link to="/programs" className="text-sm font-bold text-[#0E386B] hover:text-[#6D0C22] transition-colors flex items-center gap-1">
                 Discover More <span aria-hidden="true">&rarr;</span>
               </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}